import CrossIcon from '../icons/CrossIcon';
import CustomLocationIcon from '../icons/LocationIcon';
import CustomSearchIcon from '../icons/SearchIcon';
import DateRangePickerComponent from '../date-range-picker/DateRangePicker';
import InfoIcon from '../icons/InfoIcon';
import LocationAutocompleteComponent from '../autocomplete/LocationAutocomplete';
import PriceWidgetComponent from '../price-widget/PriceWidget';
import { BodyGrey, BodyLarge } from '../Typography';
import { Box, styled } from '@mui/material';
import { CartModalType } from './CartModal';
import { fontWeight } from '../../theme/typography';
import { HFlex, VFlex } from '../FlexContainers';
import { Modal as MUIModal, Typography } from '@mui/material';
import { palette } from '../../theme/palette';
import { PrimaryButton } from '../Buttons';
import { QuantityCounter as QuantityCounterComponent } from '../quantity-counter/QuantityCounter';

export const Modal = styled(MUIModal)``;

export const ModalContent = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 95vw;
  max-width: 640px;
  border-radius: 5px;
  box-shadow:
    0px 8px 15px 0px rgba(0, 0, 0, 0.1),
    0px -8px 15px 0px rgba(0, 0, 0, 0.1);
  background: ${palette.primary.contrastText};
  flex-shrink: 0;
  :focus-visible {
    outline: 0px;
  }
`;

export const ContentWrapper = styled(Box)`
  position: relative;
  max-height: 95vh;
  overflow-y: auto;
  :focus-visible {
    outline: 0px;
  }
`;

export const BottomsheetContentWrapper = styled(Box)``;

export const ConfigContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'cartModalType',
})<{
  cartModalType: CartModalType;
}>`
  padding: ${(props) =>
    props.cartModalType == CartModalType.CENTERED_MODAL
      ? '30px 45px 45px 45px'
      : '0px 20px 45px 20px'};
  box-sizing: border-box;
`;

export const SubmitContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'cartModalType',
})<{
  cartModalType: CartModalType;
}>`
  padding: ${(props) =>
    props.cartModalType == CartModalType.CENTERED_MODAL
      ? '20px 45px 45px 45px'
      : '20px 20px 30px 20px'};
  background: ${(props) =>
    props.cartModalType == CartModalType.CENTERED_MODAL
      ? `${palette.custom.lightGrey}`
      : `${palette.custom.white}`};
  border-top: ${(props) =>
    props.cartModalType == CartModalType.CENTERED_MODAL ? `0px` : `1px solid #ccc`};
  border-radius: ${(props) =>
    props.cartModalType == CartModalType.CENTERED_MODAL ? `0 0 5px 5px` : `0px`};
`;

export const Product = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 25px;
  @media (max-width: 786px) {
    gap: 15px;
  }
`;

export const ProductImage = styled(`img`)`
  width: 100px;
  height: 80px;
  object-fit: contain;
  @media (max-width: 786px) {
    width: 75px;
    height: 75px;
  }
`;

export const ProductDetails = styled(VFlex)``;

export const ProductName = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'cartModalType',
})<{
  cartModalType: CartModalType;
}>`
  max-width: 100%;
  flex-shrink: 0;
  color: ${palette.custom.darkGrey};
  font-style: normal;
  font-size: ${(props) => (props.cartModalType == CartModalType.CENTERED_MODAL ? `20px` : `14px`)};
  font-weight: ${(props) => (props.cartModalType == CartModalType.CENTERED_MODAL ? `800` : `700`)};
  line-height: ${(props) =>
    props.cartModalType == CartModalType.CENTERED_MODAL ? `30px` : `18px`};
  text-transform: ${(props) =>
    props.cartModalType == CartModalType.CENTERED_MODAL ? `uppercase` : `capitalize`};
  font-family: ${(props) =>
    props.cartModalType == CartModalType.CENTERED_MODAL
      ? `trade-gothic-next-condensed, sans-serif`
      : `trade-gothic-next, sans-serif`};
`;

export const BottomSheetTopBar = styled(HFlex)`
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 15px;
  padding: 0px 20px;
`;

export const BottomSheetLabel = styled(BodyLarge)`
  font-weight: ${fontWeight.bold};
  margin-bottom: 0px;
`;

export const CloseIcon = styled(CrossIcon)`
  color: ${palette.custom.grey};
  width: 21px;
  height: 21px;
  object-fit: contain;
`;

export const CloseButton = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'cartModalType',
})<{
  cartModalType: CartModalType;
}>`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${palette.primary.main};
  position: ${(props) =>
    props.cartModalType == CartModalType.CENTERED_MODAL ? 'absolute' : 'relative'};
  top: ${(props) => (props.cartModalType == CartModalType.CENTERED_MODAL ? '16px' : '0px')};
  right: ${(props) => (props.cartModalType == CartModalType.CENTERED_MODAL ? '18px' : '0px')};
`;

export const Label = styled(BodyLarge)`
  margin-bottom: 5px;
`;

export const HelperText = styled(BodyGrey, {
  shouldForwardProp: (prop) => prop !== 'hasError' && prop !== 'absolutePosition',
})<{
  hasError?: boolean;
  absolutePosition?: boolean;
}>`
  margin-top: ${(props) => (props.hasError && props.absolutePosition ? '0px' : '5px')};
  margin-left: 3px;
  margin-bottom: ${(props) => (props.hasError && props.absolutePosition ? '8px' : '0px')};
  color: ${(props) => (props.hasError ? palette.error.main : palette.custom.mediumGrey)};
  width: fit-content;
`;

export const Form = styled(VFlex)`
  gap: 22px;
`;

export const FormItem = styled(Box)``;

export const LocationAutocomplete = styled(LocationAutocompleteComponent, {
  shouldForwardProp: (prop) => prop !== 'hasError',
})<{
  hasError?: boolean;
}>`
  border-radius: 5px;
  border: ${(props) =>
    props.hasError ? `0.75px solid ${palette.error.main}` : `0.75px solid ${palette.custom.grey}`};
  height: 48px;
`;

export const SearchIcon = styled(CustomSearchIcon)`
  color: #757575;
  width: 20px;
`;

export const QuantityLabel = styled(Label)`
  font-weight: 400;
`;

export const QuantityUpdateContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 25px;
`;

export const QuantityCounter = styled(QuantityCounterComponent)`
  height: 40px;
  flex: 0;
  border-radius: 4px;
  .quantity-container {
    width: 50px;
    text-align: center;
  }
  .quantity-update-button {
    width: 40px;
  }
  .decrement-button {
    border-right: 1px solid ${palette.custom.grey};
    border-radius: 5px 0px 0px 5px;
  }
  .increment-button {
    border-left: 1px solid ${palette.custom.grey};
    border-radius: 0px 5px 5px 0px;
  }
`;

export const UpdateButton = styled(PrimaryButton)`
  flex: 1;
  flex-shrink: 0;
  padding: 0;
  height: 40px;
`;

export const PriceWidget = styled(PriceWidgetComponent, {
  shouldForwardProp: (prop) => prop !== 'cartModalType' && prop !== 'showPriceLabel',
})<{
  cartModalType: CartModalType;
  showPriceLabel: boolean;
}>`
  margin-top: 10px;
  .pricing-container {
    flex-wrap: wrap;
    gap: 5px 15px;
    min-height: ${(props) =>
      props.cartModalType == CartModalType.CENTERED_MODAL ? '30px' : '21px'};
  }
  .price-cell-typography {
    font-size: ${(props) =>
      props.cartModalType == CartModalType.CENTERED_MODAL ? '18px' : '14px'};
  }
`;

export const Seperator = styled('hr')`
  border: none;
  border-top: 1px solid #ccc;
  margin: 25px 0;
`;

export const SelectLocation = styled('a')`
  width: fit-content;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  cursor: pointer;
  font-size: 16px;
  color: ${palette.custom.darkGrey};
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  line-height: 22px;
`;

export const LocationIcon = styled(CustomLocationIcon)`
  color: ${palette.primary.main};
`;

export const DateRangePicker = styled(DateRangePickerComponent, {
  shouldForwardProp: (prop) => prop !== 'startDateError' && prop !== 'endDateError',
})<{
  startDateError?: boolean;
  endDateError?: boolean;
}>`
  .date-picker-start-date-container .date-range-picker-field .MuiInputBase-root {
    border-color: ${(props) =>
      props.startDateError ? `${palette.error.main}` : `${palette.custom.grey}`};
  }
  .date-picker-end-date-container .date-range-picker-field .MuiInputBase-root {
    border-color: ${(props) =>
      props.endDateError ? `${palette.error.main}` : `${palette.custom.grey}`};
  }
`;

export const ContactUsWrapper = styled(Box)`
  width: 100%;
  padding: 8px 16px;
  background: ${palette.custom.lightGrey};
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 0px;
`;

export const ContactUs = styled(BodyLarge)`
  display: inline;
  margin-bottom: 0;
`;

export const ContactUsNumber = styled(`a`)`
  letter-spacing: 0.35px;
  color: ${palette.custom.darkGrey};
  margin-bottom: 0px;
  width: fit-content;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
`;

export const DateNotificationContainer = styled(HFlex)`
  gap: 14.5px;
  margin-top: 20px;
`;

export const DateNotificationIcon = styled(InfoIcon)`
  color: ${palette.primary.main};
  transform: rotate(180deg);
  width: 20px;
  height: 20px;
  margin-top: 6px;
`;

export const DateNotificationText = styled(BodyLarge)`
  line-height: 24px;
  letter-spacing: 0.4px;
`;
